module.exports = __webpack_public_path__ + "static/media/argon-react.9b271c05.png";